export default class UserSetup {
  constructor(public email: string = 'null', public password: string = 'null') {}
}
